import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Resource Mapping", -1);
var _hoisted_2 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_switch = _resolveComponent("el-switch");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Resource Mapping"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingMapping,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.resourceList,
        style: {
          "width": "100%"
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name"
          }), _createVNode(_component_el_table_column, {
            prop: "direct_reportees",
            label: "Direct Reportees"
          }), _createVNode(_component_el_table_column, {
            prop: "team_members",
            label: "Team Members"
          }), _createVNode(_component_el_table_column, {
            label: "Show on leaderboard"
          }, {
            "default": _withCtx(function (scope) {
              return [_createVNode(_component_el_switch, {
                modelValue: scope.row.is_team,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.is_team = $event;
                },
                "active-text": "Yes",
                "inactive-text": "No",
                onChange: function onChange($event) {
                  return $options.disableUser(scope.row);
                },
                "class": "m-2"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"])])]);
}